import { useElementSize } from "usehooks-ts"
import { Box } from "@mui/material"
import { useCanvas } from "../../hooks/useCanvas"

interface Props {
    frameRef: React.RefObject<HTMLIFrameElement>
    data: string
}

export const Frame = ({ data, frameRef }: Props) => {
    const { canvasResolution: canvas } = useCanvas()

    const [ref, { width }] = useElementSize()

    const scale = width / canvas.width
    const height = scale * canvas.height

    return (
        <Box ref={ref}>
            <Box
                style={{
                    width,
                    height,
                    overflow: "hidden",
                    border: "1px solid #ccc",
                }}
            >
                <iframe
                    title="preview"
                    ref={frameRef}
                    srcDoc={data}
                    style={{
                        width: canvas.width,
                        height: canvas.height,
                        transform: `scale(${scale})`,
                        transformOrigin: "top left",
                        border: "none",
                    }}
                />
            </Box>
        </Box>
    )
}
